import { getRequest } from '../../httpClient';
import type { IListPublicChallengeSlugsV2Response } from './list-public-challenge-slugs-v2-response';
import { listPublicChallengeSlugsV2ResponseSchema } from './list-public-challenge-slugs-v2-response';

interface IListPublicChallengeSlugsV2Options {
  cursor?: string;
  limit?: number;
}

export async function listPublicChallengeSlugsV2Api(options?: IListPublicChallengeSlugsV2Options) {
  const params: Record<string, string | number> = {};
  if (options?.cursor) {
    params.cursor = options.cursor;
  }
  if (options?.limit) {
    params.limit = options.limit;
  }
  return getRequest<IListPublicChallengeSlugsV2Response>({
    path: '/challenges/v2/slugs',
    options: Object.keys(params).length > 0 ? { params } : undefined,
    schema: listPublicChallengeSlugsV2ResponseSchema,
  });
}
